const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Slack Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('SlackMessage', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/v3/slackmessage/:subresource/:subsubresource', null, {
    getChannels: {params: {subresource: 'channels'}, method: 'get', isArray: false},
    checkAccess: {params: {subresource: 'channel-access'}, method: 'get', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false}
  });
}]);